import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
    standalone: true,
    imports: [ButtonModule, RouterModule, CommonModule],
    selector: 'app-footer',
    template: `<div class="layout-footer">
        <div class="flex flex-row items-center justify-between gap-2 w-full">
            <ul class="flex">
                <li>
                    <p-button label="Privacy Policy" [routerLink]="['/privacy-policy']" [link]="true" />
                </li>
                <li>
                    <p-button label="Terms & Condition" [routerLink]="['/terms-condition']" [link]="true" />
                </li>
            </ul>
            <div>
                <p>&copy; {{ currentDate | date: 'YYYY' }} MyTruthStar</p>
            </div>
        </div>
    </div>`
})
export class AppFooter {
    currentDate = new Date();
}
